
export default {
    getInteraccionPorHora(state){ //take parameter state
        return state.interacciones_por_hora
    },
    getPorcentajeIntreracciones(state){
        return state.porcentaje_interacciones
    },
    getPromedios(state){
        return state.promedios
    },
    getConversaciones(state){
        return state.conversaciones
    },
    getFechaInicio(state){
        return state.fecha_inicio
    },
    getFechaFinal(state){
        return state.fecha_final
    }
}